import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4ed6029e")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 mb-xl-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-1" }, " Find out at a glance which energy suppliers provide your electricity, gas and water across your portfolio. ")
], -1)
const _hoisted_2 = { class: "card mb-2 mb-xl-3" }
const _hoisted_3 = { class: "card-body pt-2 pb-0" }
const _hoisted_4 = {
  class: "d-flex overflow-auto h-55px",
  style: {"float":"right"}
}
const _hoisted_5 = { class: "nav nav-line-tabs fs-6 fw-bolder" }
const _hoisted_6 = { class: "nav-item text-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Graph(s) ")
const _hoisted_8 = { class: "nav-item text-center" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Electricity ")
const _hoisted_10 = { class: "nav-item text-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Gas ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/AssetRegisterSupplier/CZGraphs",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "/AssetRegisterSupplier/assetElectrcityList",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/AssetRegisterSupplier/assetGasList",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}